var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("button", {
    ref: "button",
    staticClass: "button button--ghost button--icon icon--before wish-list",
    class: {
      "icon--wishlist-filled": _vm.inWishlist,
      "icon--wishlist-empty": !_vm.inWishlist,
    },
    attrs: { "data-pid": _vm.entity.order_pid },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }